import { MOBILE_AD_BOTTOM_MARGIN } from "../../../../common/constants.ts";

export const MOBILE_BOTTOM_NAV_HEIGHT_PX = 60;
export const MOBILE_FIXED_ACTION_HEIGHT_PX = 48;
export const MOBILE_NOTIFICATION_BOTTOM_GAP_PX = 8;
export const MOBILE_SAFE_AREA_INSET_BOTTOM = "env(safe-area-inset-bottom, 0px)";

type MobileBottomChromeOffsetInput = {
	extraPx?: number;
	reserveBottomChrome: boolean;
	stickyFooterAd?: boolean;
};

const px = (value: number) => `${value}px`;

const toBottomOffset = (parts: string[]) => {
	if (parts.length === 0) {
		return 0;
	}
	if (parts.length === 1) {
		return parts[0];
	}
	return `calc(${parts.join(" + ")})`;
};

export const getMobileBottomChromeOffset = ({
	extraPx = 0,
	reserveBottomChrome,
	stickyFooterAd = false,
}: MobileBottomChromeOffsetInput) => {
	const parts: string[] = [];

	if (reserveBottomChrome) {
		parts.push("var(--mobile-bottom-nav-height)");
		parts.push(MOBILE_SAFE_AREA_INSET_BOTTOM);
	}
	if (stickyFooterAd) {
		parts.push(px(MOBILE_AD_BOTTOM_MARGIN));
	}
	if (extraPx > 0) {
		parts.push(px(extraPx));
	}

	return toBottomOffset(parts);
};

export const getStickyBottomButtonsBottom = ({
	isInsideModal,
	reserveBottomChrome,
	stickyFooterAd,
}: {
	isInsideModal?: boolean;
	reserveBottomChrome: boolean;
	stickyFooterAd: boolean;
}) =>
	isInsideModal
		? -15
		: getMobileBottomChromeOffset({
				reserveBottomChrome,
				stickyFooterAd,
			});

export const getNotificationBottomOffsets = ({
	reserveBottomChrome,
	stickyFooterAd,
	stickyFormButtons,
}: {
	reserveBottomChrome: boolean;
	stickyFooterAd: boolean;
	stickyFormButtons: boolean;
}) => {
	const stickyActionOffset = stickyFormButtons
		? MOBILE_FIXED_ACTION_HEIGHT_PX
		: 0;

	return {
		ulBottom: getMobileBottomChromeOffset({
			extraPx: MOBILE_NOTIFICATION_BOTTOM_GAP_PX + stickyActionOffset,
			reserveBottomChrome,
			stickyFooterAd,
		}),
	};
};
